import { GKButton, GKModal, GKSearchSelect, Grid2 } from "components";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import { useState } from "react";
import { GET_ALL_MARKETING_MATERIAL_LIST } from "utils/apiRoutes";
import axiosInstance from "utils/axiosInstance";
import { GKModalProps } from "utils/commonInterface";
import { refetchQuery } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";

interface Props {
  id: string | number;
}

const SendMarketingMaterial = ({ open, setOpen, id }: Props & GKModalProps) => {
  const [selectedMaterial, setSelectedMaterial] = useState(null);

  const { data } = useFetchQuery({
    key: ["GET_ALL_MARKETING_MATERIAL"],
    route: GET_ALL_MARKETING_MATERIAL_LIST,
  });

  const { mutate: handleSend } = useMutation({
    mutationFn: ({
      id,
      marketingMaterialId,
    }: {
      id: any;
      marketingMaterialId: any;
    }) =>
      axiosInstance?.post(`/send_marketing_material/`, {
        lead_id: [+id],
        marketingMaterialId: marketingMaterialId,
      }),
    onSuccess: () => {
      refetchQuery(QueryKeys.GET_LEAD);
      setOpen(false);
    },
  });

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Send Marketing Material"
      footer={
        <GKButton
          disabled={selectedMaterial === null}
          variant="contained"
          onClick={() => {
            handleSend({
              id: id,
              marketingMaterialId: selectedMaterial,
            });
          }}
        >
          Send
        </GKButton>
      }
    >
      <Grid2 container>
        <Grid2 size={12}>
          <GKSearchSelect
            inputLabel="Select Material"
            getOptionLabel={(opt) => opt?.name || opt}
            onChange={(e, val) => {
              setSelectedMaterial(val?.value);
            }}
            options={
              data?.data?.data?.map((da: any) => {
                return {
                  ...da,
                  name: da?.marketingText,
                  value: da?.id,
                };
              }) || []
            }
          />
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default SendMarketingMaterial;
